<template>
<svg width="24px" height="22px" viewBox="0 0 27 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M3.936 16.239l-2.184 6.516a1 1 0 001.382 1.22L25.125 13.4a1 1 0 000-1.802L3.067.994A1 1 0 001.678 2.19l2.83 9.143a1 1 0 00.904.703l8.402.429h0l.436.022a.238.238 0 00.25-.237c0-.14-.11-.256-.25-.263L5 11.5h0" stroke="#5993FF" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
</template>
